export const paths = {
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  // Public callback opened inside the Outlook add-in's sign-in dialog: completes
  // the Supabase-Azure OAuth and posts the session back to the task pane.
  outlookAuthCallback: "/auth/outlook-callback",
  security: "/security",
  me: "/me",
  meProfile: "/me/profile",
  meAppearance: "/me/appearance",
  meNotifications: "/me/notifications",
  dashboard: "/dashboard",
  contacts: "/contacts",
  contactDetail: "/contacts/:id",
  organizations: "/organizations",
  organizationDetail: "/organizations/:id",
  deals: "/deals",
  dealDetail: "/deals/:id",
  dealRegistrations: "/deals/registrations",
  referrals: "/deals/referrals",
  partnerSubmissions: "/partner-submissions",
  partners: "/partners",
  triage: "/triage",
  prospects: "/prospects",
  activities: "/activities",
  forecast: "/forecast",

  // Partner portal — separate layout for external partner users
  partnerHome: "/partner",
  partnerDashboard: "/partner/dashboard",
  partnerRegister: "/partner/register",
  partnerRegistrations: "/partner/registrations",
  partnerDeals: "/partner/deals",
  partnerDealDetail: "/partner/deals/:id",
  partnerCommissions: "/partner/commissions",
  marketing: "/marketing",
  marketingCampaigns: "/marketing/campaigns",
  marketingLandingPages: "/marketing/landing-pages",
  marketingLandingPageEdit: "/marketing/landing-pages/:id",
  marketingLandingPageAnalytics: "/marketing/landing-pages/:id/analytics",
  admin: "/admin",
  adminUsers: "/admin/users",
  adminPipelines: "/admin/pipelines",
  adminLeadSources: "/admin/lead-sources",
  adminTerritories: "/admin/territories",
  adminAuditLog: "/admin/audit-log",
  adminRoles: "/admin/roles",
  adminPartnerCompanies: "/admin/partner-companies",
  adminReferenceTables: "/admin/reference-tables",
  adminImport: "/admin/import",
  adminDuplicates: "/admin/duplicates",
  adminDuplicatesContacts: "/admin/duplicates/contacts",
  adminDuplicatesOrganizations: "/admin/duplicates/organizations",
  adminIntegrations: "/admin/integrations",
  adminTags: "/admin/tags",
  adminTeamsWebhooks: "/admin/teams-webhooks",
  adminCommissions: "/admin/commissions",
  meIntegrations: "/me/integrations",
  outlookConnectCallback: "/me/integrations/outlook/callback",
  meCommissions: "/me/commissions",
  marketingAccountLists: "/marketing/account-lists",
  marketingAccountListDetail: "/marketing/account-lists/:id",

  // Agentic platform — Phase A (interactive chat + custom agents)
  agents: "/agents",
  agentNew: "/agents/new",
  agentDetail: "/agents/:id",
  agentDetailSettings: "/agents/:id/settings",
  agentDetailSkills: "/agents/:id/skills",
  agentDetailRuns: "/agents/:id/runs",
  agentDetailSchedules: "/agents/:id/schedules",
  agentDetailTriggers: "/agents/:id/triggers",
  conversations: "/conversations",
  conversationDetail: "/conversations/:id",
  runs: "/runs",
  runDetail: "/runs/:id",
  approvals: "/approvals",
  agentMemory: "/agents/:id/memory",
  skills: "/skills",
  skillDetail: "/skills/:id",
  templates: "/templates",
  publicLandingPage: "/l/:slug",
} as const;

export function contactDetailPath(id: string): string {
  return `/contacts/${id}`;
}

export function organizationDetailPath(id: string): string {
  return `/organizations/${id}`;
}

export function dealDetailPath(id: string): string {
  return `/deals/${id}`;
}

export function partnerDealDetailPath(id: string): string {
  return `/partner/deals/${id}`;
}

export function landingPagePath(slug: string): string {
  return `/l/${slug}`;
}

export function landingPageEditPath(id: string): string {
  return `/marketing/landing-pages/${id}`;
}

export function landingPageAnalyticsPath(id: string): string {
  return `/marketing/landing-pages/${id}/analytics`;
}

export function accountListDetailPath(id: string): string {
  return `/marketing/account-lists/${id}`;
}

export function agentDetailPath(id: string): string {
  return `/agents/${id}/settings`;
}

export function agentDetailSettingsPath(id: string): string {
  return `/agents/${id}/settings`;
}

export function agentDetailSkillsPath(id: string): string {
  return `/agents/${id}/skills`;
}

export function agentDetailRunsPath(id: string): string {
  return `/agents/${id}/runs`;
}

export function agentMemoryPath(id: string): string {
  return `/agents/${id}/memory`;
}

export function conversationDetailPath(id: string): string {
  return `/conversations/${id}`;
}

export function runDetailPath(id: string): string {
  return `/runs/${id}`;
}

export function skillDetailPath(id: string): string {
  return `/skills/${id}`;
}
